module.exports = __webpack_public_path__ + "img/aboutPicture.ac9a41a1.jpg";